import { useQuery } from '@apollo/client';
import {
  Table,
  Descriptions,
  List,
  Typography,
  Card,
  InputNumber,
  Button,
  Form,
} from 'antd';
import moment from 'moment';
import { useContext, useState, useEffect } from 'react';
import { PageContext } from '../../../lib/context';
import queries from '../../../utils/gql/queries';

const PayBills = () => {
  const {
    form,
    _submitHandler,
    selectedBill,
    payments_form,
    _onFinishPay,
    actualBalance,
  } = useContext(PageContext);
  const { data, loading, error } = useQuery(queries.GET_PAY_BILLS, {
    variables: {
      id: selectedBill?.id ?? 0,
    },
    fetchPolicy: 'no-cache',
  });

  const subs_id = (id: number): String => {
    var sub_id = `${id}`;
    while (sub_id.length < 7) {
      sub_id = `0${sub_id}`;
    }
    return sub_id;
  };

  let bill = selectedBill?.total_balance;
  let paid = selectedBill?.payments_aggregate?.aggregate?.sum?.amount;
  let remaining_balance = Math.round(actualBalance * 100) / 100;

  return (
    <div className="flex flex-row px-50">
      <div>
        <Card style={{ width: 400 }}>
          <p>
            <Descriptions.Item label="meter_id">
              {`Account No: ${subs_id(selectedBill?.subscriber?.id)}`}
            </Descriptions.Item>
          </p>
          <p>
            <Descriptions.Item label="meter_id">
              {`Bill ID: ${subs_id(selectedBill?.id)}`}
            </Descriptions.Item>
          </p>
          <p>
            <Descriptions.Item label="meter_id">
              {`Customer Name: ${selectedBill?.subscriber?.first_name} ${selectedBill?.subscriber?.last_name}`}
            </Descriptions.Item>
          </p>
          <p>
            <Descriptions.Item label="meter_id">
              {`Total Balance: ₱${remaining_balance}`}
            </Descriptions.Item>
          </p>
        </Card>
      </div>
      <div className="pl-6">
        <Card style={{ width: 320 }}>
          <div>
            <Form
              form={payments_form}
              onFinish={_onFinishPay}
              layout="vertical"
            >
              <Form.Item
                name="amount"
                rules={[{ required: true, message: 'Amount is required' }]}
                label="Enter Amount"
              >
                <div className="">
                  <InputNumber
                    placeholder="Enter Amount"
                    style={{ width: 270 }}
                  />
                </div>
              </Form.Item>
              <Form.Item hidden={true} name="payment_id">
                <InputNumber />
              </Form.Item>
              <Form.Item hidden={true} name="billing_id">
                <InputNumber />
              </Form.Item>
              <Form.Item hidden={true} name="subscriber_id">
                <InputNumber />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PayBills;
